import {Injectable} from '@angular/core';
import {AuthHttp} from 'angular2-jwt';
import {RequestOptions, Headers, Http} from "@angular/http";
import {DataService} from "./data.service";

@Injectable()
export class ApiService {
    private data;
    //private ApiUrl = 'https://bestnepal.com.np/crm/public/api/';
    //private ApiUrl = 'http://www.nepaltouristguide.com/crm/public/api/';
    //private ApiUrl = 'http://localhost/gitlab/crm/public/api/';
    private ApiUrl = 'http://www.bestnepal.com/crm/public/api/';
     //private ApiUrl = 'http://localhost/crmnew/public/api/';

    constructor(
        private http: Http,
        private authHttp: AuthHttp,
        private dataService: DataService
    ) {
    }

    getApiUrl() {
        return this.ApiUrl;
    }

    getAll(node) {
        this.dataService.updateActiveRequestNo(1);
        const url = this.ApiUrl + node + '/all';
        return this.authHttp.get(url);
    }


    getCatAll(node) {
        this.dataService.updateActiveRequestNo(1);
        const url = this.ApiUrl + node + '/cal_all';
        return this.authHttp.get(url);
    }

    getSubCatAll(node) {
        this.dataService.updateActiveRequestNo(1);
        const url = this.ApiUrl + node + '/subcatall';
        return this.authHttp.get(url);
    }


    getSubCatOnly(node,cat_id) {
        this.dataService.updateActiveRequestNo(1);
        const url = this.ApiUrl + node + '/subcatonly?id=' + cat_id;
        return this.authHttp.get(url);
    }

    getUsingId(node, id) {
        this.dataService.updateActiveRequestNo(1);
        const url = this.ApiUrl + node + '/' + id;
        return this.authHttp.get(url);
    }

    getUsingQuery(node, queryString) {
        this.dataService.updateActiveRequestNo(1);
        const url = this.ApiUrl + node + '/query?' + queryString;
        return  this.authHttp.get(url);
    }

    postNew(node, data) {
        this.dataService.updateActiveRequestNo(1);
        const url = this.ApiUrl + node + '/new';
        return this.authHttp.post(url, data);
    }

    //ids: array , data: object
    update(node, ids, data) {
        this.dataService.updateActiveRequestNo(1);
        data.ids = ids;
        const url = this.ApiUrl + node + '/update';
        return this.authHttp.put(url, data);
    }

    delete(node, ids) {
        this.dataService.updateActiveRequestNo(1);
        const url = this.ApiUrl + node + '/delete';
        return this.authHttp.post(url, {"ids": ids});
    }

    refresh(node) {
        this.dataService.updateActiveRequestNo(1);
        const url = this.ApiUrl + node + '/refresh';
        return this.authHttp.get(url);
    }

    sync(node) {
        this.dataService.updateActiveRequestNo(1);
        const url = this.ApiUrl + node + '/sync';
        return this.authHttp.get(url);
    }

    importFile(node, data) {
        this.dataService.updateActiveRequestNo(1);
        const url = this.ApiUrl + node  + '/import';
        //file upload is not working with authHttp so
        //using http to send file
        let headers = new Headers();
        headers.append('Accept', 'application/json');
        headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
        let options = new RequestOptions({headers: headers});
        return this.http.post(url, data, options);
    }

    logout() {
        this.dataService.updateActiveRequestNo(1);
        const url = this.ApiUrl + 'logout';
        return this.authHttp.get(url);
    }

}



// WEBPACK FOOTER //
// ./src/app/services/api.service.ts